module.exports = __webpack_public_path__ + "img/contact-hero.8a2030a.jpg";